
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-wallet/desktop/send-commands-to-kdf-instance",
      function () {
        return require("private-next-pages/en/docs/komodo-wallet/desktop/send-commands-to-kdf-instance/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-wallet/desktop/send-commands-to-kdf-instance"])
      });
    }
  